import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as GC from "../../common";
import * as Common from "../../common";

/**
 * UpdateAttachmentCount
 * identification   =   window.$catalog_work_plans_selectedRow.identification
 *
 *
 * */

export const UpdateAttachmentCountCommon = async (attachmentCount, identification) => {
    const model = [
        {
            op: "add",
            path: "/content/algemeen/aantalbijlagen",
            value: attachmentCount,
        },
    ];

    await omnimap.PatchMethodAction(
        model,
        identification,
        false,
        window.$catalog_management_units_token
    )
};


export const GetMediaCommon = (rowId) => {
    return new Promise(function (resolve) {
        fetch(
            `https://${process.env.REACT_APP_BASE_URL}/omnimap/generic/media/${rowId}/content`,
            {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    Authorization: "Bearer " + window.$catalog_management_units_token,
                    tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                    organisation_identification:
                    process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
                },
            }
        )
            .then((response) => response.blob())
            .then((images) => {
                // Then create a local URL for that image and print it
                let outside = URL.createObjectURL(images);
                // this.setState({ gettingMedia: outside });
                resolve(outside);
            })
            .catch((err) => alert(err));
    });
};
